import { render, staticRenderFns } from "./ExistingCase.vue?vue&type=template&id=33888d87&scoped=true"
import script from "./ExistingCase.vue?vue&type=script&lang=ts"
export * from "./ExistingCase.vue?vue&type=script&lang=ts"
import style0 from "./ExistingCase.vue?vue&type=style&index=0&id=33888d87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33888d87",
  null
  
)

export default component.exports